/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Custom_Page_Icon_FileiconInputs */

const en_enum_custom_page_icon_fileicon = /** @type {(inputs: Enum_Custom_Page_Icon_FileiconInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File`)
};

const de_enum_custom_page_icon_fileicon = /** @type {(inputs: Enum_Custom_Page_Icon_FileiconInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datei`)
};

/**
* | output |
* | --- |
* | "File" |
*
* @param {Enum_Custom_Page_Icon_FileiconInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_custom_page_icon_fileicon = /** @type {((inputs?: Enum_Custom_Page_Icon_FileiconInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Custom_Page_Icon_FileiconInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_custom_page_icon_fileicon(inputs)
	return de_enum_custom_page_icon_fileicon(inputs)
});